import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';
import "./Card.css";

export default function Card({picture, onLikeToggle, onEdit, onDelete}) {
    const { user } = useAuth();
    const [liked, setLiked] = useState(picture.likedByUser);
    const [likeCount, setLikeCount] = useState(picture.numberOfLikes || 0);

    const handleLike = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!user) return;

        // Optimistic update: flip immediately, reconcile/revert once the backend answers.
        const prevLiked = liked;
        const prevCount = likeCount;
        const nextLiked = !liked;
        setLiked(nextLiked);
        setLikeCount((c) => Math.max(0, c + (nextLiked ? 1 : -1)));

        try {
            const result = await api.likePicture(picture.publicId);
            setLiked(result.likedByUser);
            setLikeCount(result.numberOfLikes);
            if (onLikeToggle) onLikeToggle(picture.publicId, result);
        } catch {
            // Revert on failure
            setLiked(prevLiked);
            setLikeCount(prevCount);
        }
    }

    const imageUrl = picture.filesURL?.compressed || picture.filesURL?.watermarked || '';
    const owner = picture.owner;

    return (
        <div className="card">
            {(onEdit || onDelete) && (
                <div className="card-owner-actions">
                    {onEdit && (
                        <button
                            type="button"
                            className="card-action-btn"
                            title="Edit"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onEdit(picture); }}
                        >
                            <span className="material-symbols-outlined">edit</span>
                        </button>
                    )}
                    {onDelete && (
                        <button
                            type="button"
                            className="card-action-btn delete"
                            title="Delete"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onDelete(picture); }}
                        >
                            <span className="material-symbols-outlined">delete</span>
                        </button>
                    )}
                </div>
            )}
            <Link to={`/picture/${picture.publicId}`} className="picture-card-image">
                {imageUrl ? (
                    <img className="card-img" src={imageUrl} alt="img" loading="lazy"/>
                ) : (
                    <div className="card-img-placeholder">Image not available</div>
                )}
            </Link>
            <div className="inside-img">
                {owner && (
                    <Link to={`/user/${owner.publicId}`} className="artist-card-owner">
                        <span>{owner.username || 'Unknown'}</span>
                    </Link>
                )}
                {picture.price > 0 && (
                    <span className="price-card">€{picture.price}</span>
                )}
                <div className="rectangle-like">
                    <p id='likes-card'>{likeCount}</p>
                </div>
                <span
                    id={picture.publicId}
                    className={`material-symbols-outlined like-btn ${liked ? "liked" : ""} ${!user ? "disabled" : ""}`}
                    onClick={handleLike}
                >
                    {liked ? "favorite" : "favorite_border"}
                </span>
            </div>
            <Link to={`/picture/${picture.publicId}`} className="title-card">
                {picture.title || 'Untitled'}
            </Link>
        </div>
    );
}
